<div class="w-full h-full flex flex-col justify-center items-center gap-3">
  <p class="description">{{ translation.multiview.more.description | transloco }}</p>
  <assist-login-form [customReturnUrl]="dashboardMultiViewUrl()" />
</div>
